import type {
    IShikshaPipelineRiskData,
    IShikshaPipelineRiskMetricView,
    IShikshaPipelineRiskStage,
    ShikshaPipelineRiskRiskKey,
    ShikshaPipelineRiskStageKey,
} from '@app/core/models/shiksha-dashboard.model'
import { SHIKSHA_PIPELINE_RISK_STAGE_KEYS } from '../constants/shiksha-dashboard.constants'

export function getPipelineRiskStageDataByKey(
    data: IShikshaPipelineRiskData | undefined,
    stageKey: ShikshaPipelineRiskStageKey,
): IShikshaPipelineRiskStage | undefined {
    if (!data) {
        return undefined
    }
    return stageKey === SHIKSHA_PIPELINE_RISK_STAGE_KEYS.STAGE_3 ? data.stage_3 : data.stage_4
}

export function getPipelineRiskStuckAfterDaysByStageKey(
    data: IShikshaPipelineRiskData | undefined,
    stageKey: ShikshaPipelineRiskStageKey,
): number | undefined {
    const meta = data?.meta
    if (!meta) {
        return undefined
    }
    return stageKey === SHIKSHA_PIPELINE_RISK_STAGE_KEYS.STAGE_3
        ? meta.stage_3_stuck_after_days
        : meta.stage_4_stuck_after_days
}

export function createEmptyPipelineRiskMetric(params: {
    riskKey: ShikshaPipelineRiskRiskKey
    riskLabel: string
}): IShikshaPipelineRiskMetricView {
    return {
        riskKey: params.riskKey,
        riskLabel: params.riskLabel,
        leadCount: 0,
        amount: 0,
    }
}
